import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
    "inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-all duration-200 cursor-pointer select-none disabled:opacity-40 disabled:cursor-not-allowed disabled:pointer-events-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--gold)]/40 focus-visible:ring-offset-1 focus-visible:ring-offset-[var(--bg)]",
    {
        variants: {
            variant: {
                default:
                    "bg-[var(--bg2)]/80 text-[var(--fg-dim)] border border-[var(--bg3)]/50 rounded-md backdrop-blur-sm hover:bg-[var(--bg3)] hover:text-[var(--fg)] hover:border-[var(--bg4)]/60 active:scale-[0.97]",
                primary:
                    "bg-[var(--gold-dim)] text-[var(--bg-hard)] rounded-md border border-[var(--gold)]/30 hover:bg-[var(--gold)] hover:shadow-[0_0_24px_rgba(213,182,100,0.25)] active:scale-[0.97]",
                danger:
                    "bg-[var(--gold-dim)]/80 text-[var(--gold)] rounded-md border border-[var(--gold)]/25 hover:bg-[var(--gold)] hover:text-[var(--bg-hard)] hover:shadow-[0_0_24px_rgba(213,182,100,0.2)] active:scale-[0.97]",
                accent:
                    "bg-[var(--gold-dim)] text-[var(--bg-hard)] rounded-md border border-[var(--gold)]/30 hover:bg-[var(--gold)] hover:shadow-[0_0_24px_rgba(213,182,100,0.25)] active:scale-[0.97]",
                ghost:
                    "bg-transparent text-[var(--fg-muted)] rounded-md border border-transparent hover:bg-[var(--bg1)]/60 hover:text-[var(--fg)] hover:backdrop-blur-sm active:scale-[0.97]",
                outline:
                    "bg-transparent text-[var(--fg-dim)] rounded-md border border-[var(--bg3)]/60 hover:bg-[var(--bg1)]/40 hover:border-[var(--bg4)]/60 hover:text-[var(--fg)] active:scale-[0.97]",
            },
            size: {
                default: "px-5 py-2.5 text-sm",
                sm: "px-3.5 py-1.5 text-xs",
                lg: "px-7 py-3.5 text-base",
                icon: "h-9 w-9 p-0 rounded-md",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    }
);

const Button = React.forwardRef(
    ({ className, variant, size, asChild = false, ...props }, ref) => {
        const Comp = asChild ? Slot : "button";
        return (
            <Comp
                className={cn(buttonVariants({ variant, size, className }))}
                ref={ref}
                {...props}
            />
        );
    }
);
Button.displayName = "Button";

export { Button, buttonVariants };
